module.exports = __webpack_public_path__ + "static/progress1-c0253d3acbccf601d496949e8b747325.png";